// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'shield-solid';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M2 3.254V8.65c0 3.483 2.218 6.625 5.475 7.923l.763.273c.485.205 1.04.205 1.524 0l.763-.273C13.852 15.343 16 12.202 16 8.65V3.254c0-.41-.208-.82-.624-.956C13.366 1.41 11.15 1 8.931 1s-4.367.41-6.446 1.298c-.208.136-.485.546-.485.956z'
  />
);

export const viewBox = '0 0 18 18';
